export default {
  state:{
    namespaced: true,
    // ended up not needing since was able to do all lead modifications in single component but leaving in case needed in future
  }
}
